import {
  Flex,
  Input,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverArrow,
  PopoverBody,
} from '@chakra-ui/react';
import dayjs from 'dayjs';
import { DayPicker } from 'react-day-picker';
import { useField } from 'formik';
import { useSelector } from 'react-redux';
import { selectUser } from '@/store/bootstrap/selectors';
import './index.css';
import 'react-day-picker/dist/style.css';
import { KText } from '@/ui-library/components/text';

const DatePickerField = ({ onChange, label, fieldKey }) => {
  const [field, meta, helpers] = useField(fieldKey);
  const { setValue, setTouched, setError } = helpers;
  const { value } = field;
  const { error, touched } = meta;
  const currUser = useSelector(selectUser);
  const { date_fmt } = currUser || {};

  const setFieldProps = (date) => {
    setValue(date);
    onChange(date);
    setTouched(true);
    setError(null);
  };

  const formatDay = value
    ? dayjs(value).format(date_fmt === 'DD-MM-YYYY' ? 'DD/MM' : 'MM/DD')
    : '';
  const isError = touched && error && !value;

  return (
    <Flex flexDir="column" w="100%" margin="0.75em 0">
      <KText size="sm-medium" color="secondary-900" mb="8px">
        {label}
        <KText as="span" color="#E53E3E" fontSize="sm">
          *
        </KText>
      </KText>
      <Popover>
        {({ onClose }) => (
          <>
            <PopoverTrigger>
              <Input
                variant="outline"
                border="2px solid #E9EBF4 !important"
                fontSize="14px"
                placeholder={date_fmt === 'DD-MM-YYYY' ? 'DD/MM' : 'MM/DD'}
                value={formatDay}
                h="52px"
                boxShadow={isError && '0 0 0 2px #A32020'}
                isInvalid={false}
              />
            </PopoverTrigger>
            <PopoverContent>
              <PopoverArrow />
              <PopoverBody>
                <DayPicker
                  mode="single"
                  className="schedule-date-picker"
                  numberOfMonths={1}
                  showHeading={false}
                  selected={value}
                  onSelect={(date) => {
                    setFieldProps(date);
                    onClose();
                  }}
                  disabled={[{ before: new Date() }]}
                />
              </PopoverBody>
            </PopoverContent>
          </>
        )}
      </Popover>
      {isError && (
        <KText color="ats-negative" size="sm" mt="8px">
          {error}
        </KText>
      )}
    </Flex>
  );
};

export default DatePickerField;
